/* eslint-disable  */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Head from 'next/head';
import Image from 'next/image';
import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import card1 from '@/assets/images/icons/mfo-employee-1.jpg';
import card2 from '@/assets/images/icons/mfo-employee-2.jpg';
import card3 from '@/assets/images/icons/mfo-employee-3.jpg';
import card4 from '@/assets/images/icons/mfo-employee-4.jpg';
import blogDummy from '@/assets/images/blog-dummy.png';
import financialApp from '@/assets/images/financial_app.svg';
import appStore from '@/assets/images/icons/app-store.svg';
import mission from '@/assets/images/icons/mission.svg';
import muthootIcon from '@/assets/images/icons/muthoot.svg';
import playStore from '@/assets/images/icons/play-store.svg';
import valuesIcon from '@/assets/images/icons/values.svg';
import videoPlay from '@/assets/images/icons/video-play.svg';
import vision from '@/assets/images/icons/vision.svg';
import { blogsSettings } from '@/utils/config/AboutUs/blogsSettings';
import { AboutUsSEO } from '@/utils/constants/MetaData';
import AboutUsHero from '@/assets/images/icons/AboutUsHero.png';
import AllInOne from '@/common/components/Prelogin/AllInOne';

// false commit
const About = () => {
  const videoRef = useRef<any>();
  const [playing, setPlaying] = useState(false);
  // const [currentTime, setCurrentTime] = useState(0);

  const togglePlayPause = () => {
    setPlaying(!playing);
    if (playing === false) {
      videoRef.current.play();
    }
    if (playing === true) {
      videoRef.current.pause();
    }
  };

  const onPlaying = () => {
    // TODO: Clean this function
    // setCurrentTime(videoRef.current.currentTime);
  };

  return (
    <>
      <Head>
        <title>{AboutUsSEO.metaTitle}</title>
        <meta name="description" content={AboutUsSEO.metaDescription} />
        <meta
          property="og:description"
          content={AboutUsSEO.metaOGDescription}
        />
        <link rel="canonical" href="https://muthootfincorpone.com/about-us/" />
      </Head>
      <main className="home withHeader who mfone-about-us">
        <section className="bg bg--dark who__hero">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <h1 className="section__title text--white">
                  +135 Years Plus of Legacy, powered by your trust
                </h1>
              </div>
              <div
                className="video m-2 mt-2"
                // style={{ margin: "10px" }}
              >
                {/* col-lg-7 */}
                {/* <div className="video">
                <video
                  controls={false}
                  controlsList="nodownload"
                  poster="images/who-hero.png"
                  autoPlay={true}
                  ref={videoRef}
                  onPlay={() => setPlaying(true)}
                  onPause={() => setPlaying(false)}
                  onTimeUpdate={onPlaying}
                >
                  // <source src="" type="video/mp4" />
                  <source src="vidoes/marketing_video1.mp4" type="video/mp4" />
                </video>
                <a
                  id="play"
                  data-state="play"
                  style={{ border: 'none', background: 'none' }}
                  onClick={togglePlayPause}
                >
                  {playing ? (
                    <Image 
style={{ color: undefined }} src={videoPlay} alt="" className="play-btn-new" />
                  ) : (
                    <Image 
style={{ color: undefined }}
                      src={videoPlay}
                      alt="video"
                      className="play-btn-new"
                    />
                  )}
                </a>
              </div> */}
                <Image
                  style={{ color: undefined }}
                  src={AboutUsHero}
                  alt="About us hero"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="with-padding eco">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-xl-4">
                <h2 className="section__title text--black mfone-our-story">
                  {/* <span className="text--darkBlue">Our</span>
                  <span>Story</span> */}
                  <span>Our Story</span>
                </h2>
              </div>
              <div className="col-lg-6">
                <p
                  // className="text--gray text--regular eco__text"
                  // style={{ textAlign: "justify" }}
                  className="custom-mfone-our-story-info"
                >
                  At Muthoot FinCorp ONE, as an SBU of Muthoot FinCorp Ltd., we
                  are creating a unique, transparent financial ecosystem through
                  digital products across our services. These include Gold Loans
                  from home and more. We continue to uphold the values of our
                  parent, the Muthoot Pappachan Group by providing you with
                  easily accessible services, replete with our unmistakable
                  quality.{' '}
                </p>
                <br></br>
                <p
                  // className="text--gray text--regular eco__text"
                  // style={{ textAlign: "justify" }}
                  className="custom-mfone-our-story-info"
                >
                  The Muthoot Pappachan Group, is among India’s most reputed
                  names in the Financial services industry, with customers in
                  diverse segments like Automotive industry, Financial Services,
                  Hospitality, Alternate Energy, Real Estate, and Precious
                  Metals.{' '}
                </p>
                <br />
                <p
                  // className="text--gray text--regular eco__text"
                  className="custom-mfone-our-story-info"
                >
                  At Muthoot FinCorp ONE, we are building a holistic financial
                  ecosystem using the latest digital products for lending,
                  saving and investing, protection and remittances. We aim to
                  create products that provide a secure and reliable financial
                  environment for our customers with an enhanced user
                  experience.{' '}
                </p>
                <br></br>
                {/* <p
                  className="text--gray text--regular eco__text"
                  style={{ textAlign: "justify" }}
                >
                  We also acquired Paymatrix, an award-winning start-up founded
                  in 2016. It has helped us venture into rent, rent-related, and
                  other vendor payments using credit cards.
                </p> */}
              </div>
            </div>
          </div>
        </section>
        <section className="bg bg--light know">
          <div className="container">
            <h2 className="text--black text--bold section__title-small text-center">
              Our Mission and Vision
            </h2>
            <div
              className="row justify-content-md-centred-flex justify-content-center"
              // style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="col-lg-4">
                <div className="know__card mb-lg-0">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={vision}
                    alt="vision icon"
                  />
                  <p className="text--bold text--black title">Vision</p>
                  <p className="text--gray text--regular desc">
                    To be the most trusted and best product-led financial
                    services platform to serve customers with ease and speed
                    throughout their lifecycle through omni channel model.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="know__card mb-lg-0">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={mission}
                    alt="mission icon"
                  />
                  <p className="text--bold text--black title">Mission</p>
                  <p className="text--gray text--regular desc">
                    Improve the well-being of customers by providing best in
                    class financial services through technology.
                  </p>
                </div>
              </div>
              {/* <div className="col-lg-4">
                <div className="know__card mb-lg-0 mb-0">
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={valuesIcon}
                    alt="values icon"
                  />
                  <p className="text--bold text--black title">Values</p>
                  <p className="text--gray text--regular desc">
                    To be the most trusted financial service provider, in the
                    reach of every commoner, satisfying his needs with easy to
                    use products.
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </section>
        <section className="bg home-trust">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 order-lg-1 order-2">
                <h2 className="section__title-small text--black text--bold">
                  About the <br /> Muthoot Pappachan Group
                </h2>
                <p className="section__desc text--gray">
                  Our extreme customer-centric approach and innovation in terms
                  of new products that cater to changing customer needs, have
                  helped in winning the loyalty of innumerable customers, as
                  well as in attracting new ones. Adopting the latest technology
                  and new ways to serve customers, without compromising on basic
                  principles and ethics we have been following since our
                  inception, is what drives the Group.
                </p>
                <div className="d-flex align-items-center trust__counter">
                  <div className="item">
                    <p className="text--bold text--black number">
                      135 <span className="text--darkBlue">+</span>
                    </p>
                    <p className="text--regular text--gray title">
                      Years of Legacy
                    </p>
                  </div>
                  <div className="item">
                    <p className="text--bold text--black number">
                      1 cr <span className="text--darkBlue">+</span>
                    </p>
                    <p className="text--regular text--gray title">
                      Happy Customers
                    </p>
                  </div>
                  <div className="item">
                    <p className="text--bold text--black number">
                      4500 <span className="text--darkBlue">+</span>
                    </p>
                    <p className="text--regular text--gray title">Branches</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 order-lg-2 order-1 text-center">
                <Image
                  style={{ color: undefined }}
                  className="img-fluid about-img"
                  src={muthootIcon}
                  alt="muthoot logo"
                />
              </div>
            </div>
          </div>
        </section>
        {/* removed as per business requirements */}
        {/* <section className="bg bg--light blogs blogs-padding">
          <div className="container">
            <h2 className="section__title-small text--black text--bold mb-8">
              Top reads on the latest trends
            </h2>
          </div>
          <div className="blogs__slider blogs--page-container">
            <Slider {...blogsSettings}>
              <a href="#blog1" className="blogs__card blogs__card__new">
                <div className="blogs__card-figure">
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={blogDummy}
                    alt="blog dummy"
                  />
                  <div className="chips chips--lightBlack">Investment</div>
                </div>
                <div className="blogs__card-content">
                  <p className="text--black text--bold title">
                    Digital Gold Explained
                  </p>
                  <p className="text--gray text--regular desc">
                    When technology has changed how we shop, why should gold be
                    left behind?
                  </p>
                </div>
              </a>
              <a href="#blog1" className="blogs__card blogs__card__new">
                <div className="blogs__card-figure">
                  <Image 
style={{ color: undefined }} className="img-fluid" src={blogDummy} alt="" />
                  <div className="chips chips--lightBlack">Investment</div>
                </div>
                <div className="blogs__card-content">
                  <p className="text--black text--bold title">
                    Digital Gold Explained
                  </p>
                  <p className="text--gray text--regular desc">
                    When technology has changed how we shop, why should gold be
                    left behind?
                  </p>
                </div>
              </a>
              <a href="#blog1" className="blogs__card blogs__card__new">
                <div className="blogs__card-figure">
                  <Image 
style={{ color: undefined }} className="img-fluid" src={blogDummy} alt="" />
                  <div className="chips chips--lightBlack">Investment</div>
                </div>
                <div className="blogs__card-content">
                  <p className="text--black text--bold title">
                    Digital Gold Explained
                  </p>
                  <p className="text--gray text--regular desc">
                    When technology has changed how we shop, why should gold be
                    left behind?
                  </p>
                </div>
              </a>
              <a href="#blog1" className="blogs__card blogs__card__new">
                <div className="blogs__card-figure">
                  <Image 
style={{ color: undefined }} className="img-fluid" src={blogDummy} alt="" />
                  <div className="chips chips--lightBlack">Investment</div>
                </div>
                <div className="blogs__card-content">
                  <p className="text--black text--bold title">
                    Digital Gold Explained
                  </p>
                  <p className="text--gray text--regular desc">
                    When technology has changed how we shop, why should gold be
                    left behind?
                  </p>
                </div>
              </a>
              <a href="#blog1" className="blogs__card blogs__card__new">
                <div className="blogs__card-figure">
                  <Image 
style={{ color: undefined }} className="img-fluid" src={blogDummy} alt="" />
                  <div className="chips chips--lightBlack">Investment</div>
                </div>
                <div className="blogs__card-content">
                  <p className="text--black text--bold title">
                    Digital Gold Explained
                  </p>
                  <p className="text--gray text--regular desc">
                    When technology has changed how we shop, why should gold be
                    left behind?
                  </p>
                </div>
              </a>
            </Slider>
          </div>
        </section> */}
        {/* <section className="bg bg--dark downloadCta pb-0">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-7">
                <h2 className="section__title text--white">
                  Download India’s Most Trusted{" "}
                  <span className="text--yellow">Financial App</span>
                </h2>
                <p className="section__desc text--white-80">
                  The Muthoot Pappachan Group, with a reputation that has been
                  shaped over decades with high quality practices, total
                  customer satisfaction and steady growth.
                </p>
                <div className="d-flex align-items-center appLinks">
                  <a href="#" target="_blank">
                    <Image 
style={{ color: undefined }}
                      className="img-fluid"
                      src={playStore}
                      alt="Google Play Store"
                    />
                    <span className="sr-only">Google Play Store</span>
                  </a>
                  <a href="#" target="_blank">
                    <Image 
style={{ color: undefined }}
                      className="img-fluid"
                      src={appStore}
                      alt="App Store"
                    />
                    <span className="sr-only">App Store</span>
                  </a>
                </div>
              </div>
              <div className="col-lg-5">
                <Image 
style={{ color: undefined }}
                  className="img-fluid right-image"
                  src={financialApp}
                  alt="Financial App | One Muthoot"
                />
              </div>
            </div>
          </div>
        </section> */}
        <AllInOne />

        <section className="home__faq with-padding">
          <div className="container">
            <h2 className="section__title-small text--black text--bold">
              Frequently Asked Questions
            </h2>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_1"
              >
                <p>What is a Gold Loan from Home? </p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_1">
                <p>
                  A Gold Loan from Home is a service where you can get a Gold
                  Loan at your home, unlike the traditional Gold Loan where you
                  visit a Bank or an NBFC. We process your Gold Loan at your
                  home seamlessly. Our loan managers will carry your gold
                  jewellery safely to a nearby Muthoot FinCorp branch, so you
                  don’t have to worry about traveling with your gold jewellery.
                  <br />
                  **Available in selected cities
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_2"
              >
                <p>What are the benefits of getting a Gold Loan from Home? </p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_2">
                <p>
                  When you book an appointment for a Gold Loan from Home, we
                  come to your home to collect the gold jewellery at your
                  preferred date and time, making the process easy, hassle-free,
                  and seamless. Additionally, we carry your pledged gold
                  jewellery to a nearby Muthoot FinCorp branch in a GPS-tracked
                  safe locker, so you don’t have to carry it yourself. Your
                  pledged gold jewellery is automatically insured as an added
                  layer of protection.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_3"
              >
                <p>What is eSwarna Digital Gold?</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_3">
                <p>
                  eSwarna Digital Gold is the virtual method of buying and
                  investing in gold without having to physically hold the gold.
                  When you buy eSwarna Digital Gold on Muthoot FinCorp ONE
                  platform, the corresponding physical gold is stored at secure
                  vaults by Muthoot EXIM appointed custodian Sequel Logistics
                  completely free of cost.
                  <br />
                  Your gold is always 100% safe and secure at no extra cost.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_4"
              >
                <p>What is the Purity of Gold?</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_4">
                <p>
                  Muthoot EXIM offers 999 fineness also known as 24 karat purity
                  through Muthoot FinCorp ONE platform.
                </p>
              </div>
            </div>
            {/* <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_5"
              >
                <p>
                  How can I exchange my eSwarna Digital Gold for Physical Jewellery?
                </p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_5">
                <p>
                  Digital gold is a form of electronic money based on mass units
                  of gold. It is a kind of representative money, like a US paper
                  gold certificate at the time that these were exchangeable for
                  gold on demand
                </p>
              </div>
            </div> */}
            {/* <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_6"
              >
                <p>Why is the buy and sell price different on the same day?</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_6">
                <p>
                  Digital gold is a form of electronic money based on mass units
                  of gold. It is a kind of representative money, like a US paper
                  gold certificate at the time that these were exchangeable for
                  gold on demand
                </p>
              </div>
            </div> */}
          </div>
        </section>
      </main>
    </>
  );
};

export default About;
